export default "__VITE_ASSET__B7zTgrCc__"